const ALLOWED_ROLES = {
  'all': ['accountant', 'management_admin', 'management', 'super_admin'],
  'admins': ['management_admin', 'super_admin'],
  'accountants': ['accountant', 'super_admin'],
  'management': ['management_admin', 'management', 'super_admin'],
  'accountantAdmin': ['super_admin'],
  'managementAdmin': ['management_admin', 'super_admin'],
  'none': [],
};

/**
 * Whether the user's roles grant access to a screen group.
 *
 * Both arguments are defensive on purpose: `roles` comes from a token claim, so
 * an identity provider that does not emit it yields `undefined`. Throwing here
 * white-screens the whole app instead of sending the user back to /auth, which
 * is what happened the first time payment-site pointed at Zitadel. Anything that
 * is not a list of roles means "no roles", which denies access.
 */
export const verifyRole = (roles, type) => {
  if (!Array.isArray(roles)) return false;
  const allowedForType = ALLOWED_ROLES[type];
  if (!allowedForType) return false;
  return roles.some((role) => allowedForType.includes(role));
};
